// @flow

import Payin from 'PMT/entities/Payin';

import DateUtils from 'PMT/utils/DateUtils';

/**
 * Represents all the payment for a table.
 */
export default class PayinsForTable {

  /**
   * Contains the total paid by the user (with tips)
   * @type {number}
   */
  amount: Number = 0;

  tips: Number = 0;

  fees: Number = 0;

  totalTable: Number = 0;

  payins: Array<Payin> = [];

  date: Number = 0;

  checkId: String = '';

  getFormattedDate(format: string = 'DD/MM/Y'): string {
    return DateUtils.fromSecondsTimestampToString(this.date, format);
  }

  getFormattedHour(format: string = 'HH:mm'): string {
    return DateUtils.fromSecondsTimestampToString(this.date, format);
  }
}
